<ng-content select="a3l-dataset-grid" *ngIf="layout == 'grid'"></ng-content>
<ng-content select="[a3l-dataset-table]" *ngIf="layout == 'table'"></ng-content>
